import React, { useEffect, useState } from "react";
import { PolotnoContainer, SidePanelWrap, WorkspaceWrap } from "polotno";
import { Toolbar } from "polotno/toolbar/toolbar";
import { PagesTimeline } from "polotno/pages-timeline";
import { ZoomButtons } from "polotno/toolbar/zoom-buttons";
import { Workspace } from "polotno/canvas/workspace";
import { runInAction } from "mobx";
import { observer } from "mobx-react-lite";
import "@blueprintjs/core/lib/css/blueprint.css";
import { createStore } from "polotno/model/store";
import { Link, useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import { dimensions } from "../../../utils/helper";
// import { PageControls } from "./PageControls";
import { Button, EditableText, Tooltip } from "@blueprintjs/core";
import { t } from "polotno/utils/l10n";
import FontComponant from "../../../design/FontComponant";
import "./Polotno.css";
import { config } from "../../../utils/config";
import { changeDpiDataUrl } from "changedpi";
import CustomPageTimeline from "./CustomPageTimeline";
import { useDispatch } from "react-redux";
import { setDesignStore } from "../../../redux/slices/variationSlice";

const store = createStore({
  key: "gj22OYPNEiZGOv4RvhGx",
  showCredit: false,
});
// const masterPage = store.addPage({
//   name: "master",
//   width: dimensions.M.width,
//   height: dimensions.M.height,
//   id: "master",
//   custom: {
//     size: "M",
//     inch: dimensions["M"]?.inch,
//     pixels: `${dimensions["M"]?.width} X ${dimensions["M"]?.height} px`,
//   },
// });
store.setUnit({
  unit: "in",
  dpi: 72, // Set this right after store initialization
});

console.log("DPI after setting:", store.dpi);

export default function PolotnoDesign({ store }) {
  const dispatch = useDispatch();
  const userLoginDetails = localStorage.getItem(config.USER_LOGIN_DETAILS);
  if (!userLoginDetails) {
    alert("please login first");
    navigate("/Login");
  }

  const [sizeFormat, setSizeFormat] = useState("inch");
  const [storeJson, setStoreJson] = useState(null);
  const [showTimeline, setShowTimeline] = useState(false);
  const [allPagesCreated, setAllPagesCreated] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const [isBgEditable, setIsBgEditable] = useState(false);
  const [allThumbs, setAllThumbs] = useState([]);
  const [smThumbs, setSmThumbs] = useState(true);
   const [thumbnails, setThumbnails] = useState([]);
  const [activePageId, setActivePageId] = useState(
    store.activePage?.id || "master"
  );
  const [renderOnlyActivePage, setRenderOnlyActivePage] = useState(
    activePageId !== "master"
  );

  useEffect(() => {
    console.log("allThumbs are ", allThumbs);
  }, [allThumbs]);

    const delay = 100;

    const generateThumbnail = async (page) => {
      if (!page) return "";
    
      // Create a canvas element
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d", { willReadFrequently: true });
    
      // Set canvas dimensions
      canvas.width = page.width;
      canvas.height = page.height;
    
      // Explicitly clear the canvas to ensure transparency
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    
      // Render the page onto the canvas (this should preserve transparency if the page itself has transparency)
      await store.renderPage(page, ctx);
    
      // Convert the canvas to PNG, which supports transparency
      return canvas.toDataURL("jpeg/png"); // PNG is the format that supports transparency
    };
    
  
    useEffect(() => {
      if (!allThumbs.length) {
        return;
      }
  
      let isMounted = true;
  
      const loadThumbnails = async () => {
        let loadedThumbnails = [];
      
        for (let index = 0; index < store.pages.length; index++) {
          const page = store.pages[index];
          const image = allThumbs[index] || (await generateThumbnail(page)); // Ensure transparent PNG
      
          loadedThumbnails.push({
            id: page.id,
            image,
            isActive: page.id === "master" || store.activePage?.id === page.id, 
            label: index === 0 ? "Master" : Object.keys(dimensions)[index - 1],
          });
      
          setThumbnails([...loadedThumbnails]);
      
          await new Promise((resolve) => setTimeout(resolve, 100)); 
        }
      };
      
  
      loadThumbnails();
  
      return () => {
        isMounted = false;
      };
    }, [allThumbs, store.pages, store.activePage]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Alt") {
        e.preventDefault();
        setShowTooltip(true);
      }
    };

    const handleKeyUp = (e) => {
      if (e.key === "Alt") {
        e.preventDefault();
        setShowTooltip(false);
      }
    };

    document.addEventListener("keydown", handleKeyDown, true);
    document.addEventListener("keyup", handleKeyUp, true);
    addAllPages();

    return () => {
      document.removeEventListener("keydown", handleKeyDown, true);
      document.removeEventListener("keyup", handleKeyUp, true);
    };
  }, []);

useEffect(() => {
  if (showTimeline) {
    setActivePageId(store.activePage?.id || "master");
  }
}, [showTimeline, store.activePage?.id]);

useEffect(() => {
  setRenderOnlyActivePage(activePageId !== "master");
}, [activePageId]);
  

  const TextAiWrite = () => null;

   const handlePageClick = (pageId) => {
      if (!pageId) return;
    
      console.log("Page selected:", pageId); // Debugging
      runInAction(() => {
        store.selectPage(pageId);
        setActivePageId(pageId);
      });
    
      setShowTimeline(false);
    };

  const convertBackgroundToImage = (masterPage, targetPage) => {
    if (!masterPage || !targetPage) return;

    const bgValue = masterPage.background; // Background color or image URL

    // Initially, set the background (locked)
    targetPage.set({ background: bgValue });
  };

  const handleUnlockClick = () => {
    const activePage = store.activePage;
    if (!activePage) return;

    setIsBgEditable((prev) => {
      runInAction(() => {
        const existingBg = activePage.children.find(
          (child) => child.name === "background-image"
        );

        if (existingBg) {
          if (!prev) {
            // Unlock background (Make draggable & selectable)
            existingBg.set({
              selectable: true,
              evented: true,
              lockScalingX: false,
              lockScalingY: false,
              lockMovementX: false,
              lockMovementY: false,
            });
          } else {
            // Lock background (Prevent dragging & scaling)
            existingBg.set({
              selectable: false,
              evented: false,
              lockScalingX: true,
              lockScalingY: true,
              lockMovementX: true,
              lockMovementY: true,
            });
          }
        } else {
          // Convert background to image only if it doesn't exist
          const bgValue = activePage.background;
          if (!bgValue || bgValue === "transparent") return;

          runInAction(() => {
            activePage.set({ background: "transparent" });

            activePage.addElement({
              id: `background-image-${activePage.id}`,
              name: "background-image",
              type: "image",
              src: bgValue,
              x: 0,
              y: 0,
              width: activePage.width,
              height: activePage.height,
              selectable: true,
              evented: true,
              lockScalingX: false,
              lockScalingY: false,
              lockMovementX: false,
              lockMovementY: false,
            });
          });
        }
      });

      return !prev;
    });
  };

  console.log("store is", store.activePage.children[0]);
  const changeHandler = async (navigateToExport) => {
    const masterPage = store.pages.find((page) => page.id === "master");
    if (store.activePage?.id === "master") {
      store.pages.forEach(async (page) => {
        if (page.id !== "master") {
          const arr = [page];
          await Promise.all(
            arr.map(async (item) => {
              try {
                await syncChanges(masterPage, item);
              } catch (error) {
                console.log("error is", error);
              }
            })
          );
          await sleep(50);
        }
      });
      let imgArr = [];
      for (let i = 0; i < store.pages.length; i++) {
        const blob = await store.toDataURL({
          pageId: store.pages[i].id,
          quality: 0.3,
          mimeType: "image/jpeg",
        });
        imgArr.push(changeDpiDataUrl(blob, 72));
      }
      setAllThumbs(imgArr);
      if (navigateToExport) {
        const json = await JSON.stringify(store.toJSON());
        dispatch(setDesignStore(json))
        navigate("/export", {
          state: {
            storeVal: json,
            isChanged: isChanged,
          },
        });
      }
    }
  };

  const addAllPages = async (navigateToExport) => {
    if (store.pages.length > 1) {
      console.log("Pages already exist, skipping creation.");
      return;
    }
  
    Object.keys(dimensions)?.forEach((size) => {
      const existingPage = store.pages.find(
        (page) => page.id === size.split(" ").join("_")
      );
      if (!existingPage) {
        const { inch } = dimensions[size];
        const [widthInInches, heightInInches] = inch
          .split(" X ")
          .map((val) => parseFloat(val));
        dimensions[size].width = widthInInches * 72;
        dimensions[size].height = heightInInches * 72;
  
        store.addPage({
          name: size.split(" ").join("_"),
          width: widthInInches * 72,
          height: heightInInches * 72,
          id: size.split(" ").join("_"),
          background: "rgba(0,0,0,0)",
          custom: {
            size: size,
            inch: dimensions[size]?.inch,
            pixels: `${dimensions[size]?.width} X ${dimensions[size]?.height}`,
          },
        });
      }
    });
  
    store.selectPage("master");
    setAllPagesCreated(true);
    changeHandler(navigateToExport);
  };
  

  const timelineHandler = () => {
    if (!allPagesCreated) {
      addAllPages();
    }
    setShowTimeline((prev) => !prev);
    setSmThumbs(false)
  };

  const refreshHandler = (isMasterRefresh = false) => {
    // setShowTimeline(false);
    setIsChanged(true);

    const masterPage = store.pages.find((page) => page.id === "master");
    if (!masterPage) {
      return;
    }

    runInAction(() => {
      store.pages.forEach((page) => {
        if (page.id !== "master") {
          // ✅ Remove background images **only if it's a master refresh**
          if (isMasterRefresh) {
            const existingBg = page.children.find(
              (child) => child.name === "background-image"
            );
            if (existingBg) {
              store.deleteElements(existingBg.id);
            }

            page.set({ background: masterPage.background });
          }
        }
      });
    });

    setTimeout(() => {
      changeHandler();
    }, 100);
  };

  const removeSelectedElementFromActivePage = () => {
    const activePage = store.activePage;
    if (!activePage) return;

    const ids = store.selectedElements.map((el) => el.id);
    if (!ids.length) return;

    runInAction(() => {
      const updatePage = (page) => {
        page.set({
          custom: {
            ...page.custom,
            removedElements: [...(page.custom?.removedElements || []), ...ids],
          },
        });

        page.children.forEach((child) => {
          if (ids.includes(child.id)) {
            child.set({ opacity: 0, selectable: false, evented: false }); // Hide element
          }
        });
      };

      // Remove from all pages if master, otherwise just active page
      activePage.id === "master"
        ? store.pages.forEach(updatePage)
        : updatePage(activePage);
    });
  };

  const smTimeLineHandler = () => {
    setSmThumbs(!smThumbs);
    setShowTimeline(false);
  }

  const Remove = observer(({ store }) => {
    return (
      <button
        style={{
          background: "red",
          color: "white",
          border: "none",
          padding: "8px 12px",
          cursor: "pointer",
          borderRadius: "5px",
        }}
        onClick={() => removeSelectedElementFromActivePage(store)}
      >
        Remove Element
      </button>
    );
  });

  // const syncChanges = (masterPage, targetPage) => {
  //   runInAction(() => {
  //     const targetElementsMap = new Map(targetPage.children.map((child) => [child.id, child]));
  //     const removedElements = new Set([
  //       ...(targetPage.custom?.removedElements || []),
  //       ...(masterPage.custom?.removedElements || []),
  //     ]);

  //     masterPage.children.forEach((masterObject) => {
  //       const masterData = masterObject.toJSON();
  //       console.log('masterData is', masterData, ' and masterObject is', masterObject)
  //       if (removedElements.has(masterData.id)) return; // Skip removed elements

  //       const targetObject = targetElementsMap.get(masterData.id);
  //       targetObject ? targetObject.set(masterData) : targetPage.addElement(JSON.parse(JSON.stringify(masterData)));
  //     });
  //   });
  // };
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const syncChanges = async (masterPage, targetPage) => {
    runInAction(() => {
      console.log("inside syncchanges");
      convertBackgroundToImage(masterPage, targetPage);
      const targetElementsMap = new Map(
        targetPage.children.map((child) => [child.id, child])
      );
      const removedElements = new Set([
        ...(targetPage.custom?.removedElements || []),
        ...(masterPage.custom?.removedElements || []),
      ]);
      masterPage.children.forEach((masterObject) => {
        const masterData = masterObject.toJSON();
        if (removedElements.has(masterData.id)) return;
        const uniqueId = `${masterData.id}-${targetPage.id}`;
        const targetObject = targetElementsMap.get(uniqueId);

        const relativeX = masterData.x / masterPage.width;
        const relativeY = masterData.y / masterPage.height;

        let newX;
        if (relativeX >= 0.05 && relativeX <= 0.55) {
          newX = (targetPage.width - masterData.width) / 2;
        } else {
          newX = targetPage.width * relativeX;
        }
        const newY = targetPage.height * relativeY;
        if (targetObject) {
          const obj = {
            ...masterData,
            align: "center",
            id: targetObject.id,
            x: newX,
            y: newY,
          };
          targetObject.set(obj);
        } else {
          const obj = {
            align: "center",
            ...masterData,
            id: uniqueId,
            x: newX,
            y: newY,
          };
          targetPage.addElement({
            ...obj,
          });
        }
      });
    });
    setStoreJson(JSON.stringify(store.toJSON()));
  };

  useEffect(() => {
    let obj = {
      name: false,
      number: false,
    };
    if (localStorage.getItem("fieldStatus")) {
    } else {
      localStorage.setItem("fieldStatus", JSON.stringify(obj));
    }
    const changeHandler = () => {
      const masterPage = store.pages.find((page) => page.id === "master");
      if (store.activePage?.id === "master") {
        store.pages.forEach((page) => {
          if (page.id !== "master") {
            syncChanges(masterPage, page);
          }
        });
      }
    };

    const unsubscribe = store.on("change", (newState, prevState) => {
      console.log("Previous State:", prevState);
      console.log("New State:", newState);
      // setIsChanged(true);
      setStoreJson(JSON.stringify(store.toJSON()));
      // localStorage.setItem("polotnoCanvas", JSON.stringify(store.toJSON()));
      // changeHandler();
    });
    // return () => {
    //   unsubscribe();
    // };
  }, []);

  const addOrRemoveName = (page) => {
    console.log("found inside addorremovename");
    const centerX = page.width / 2;
    const centerY = page.height / 2;
    const found = page?.children?.find((child) => {
      return child.id === page.id + "_playernametext";
    });
    if (found) {
      found.set({ visible: !found.visible, x: centerX, y: centerY });
    } else {
      page.addElement({
        id: page.id + "_playernametext",
        type: "text",
        fill: "black",
        text: "Player Name",
        fontSize: 547,
        lineHeight: 1.2,
        width: 3285,
        height: 610,
        x: centerX - 3285 / 2,
        y: 1743,
      });
    }
  };

  const handleAddName = () => {
    const activePage = store.activePage;
    if (activePage && activePage.id === "master") {
      store.pages.forEach((page) => {
        addOrRemoveName(page);
      });
    } else {
      const foundPage = store.pages.find((page) => page.id === activePage.id);
      if (foundPage) {
        addOrRemoveName(foundPage);
      }
    }
    // console.log("activepage is", activePage);
  };

  const navigate = useNavigate();

  const navigateHomePage = () => {
    navigate("/Design", {
      state: {
        storeVal: storeJson,
      },
    });
  };
  // const navigateVariationPage = () => {
  //   navigate("/vari");
  // };
  const navigateExportPage = () => {
    if (store.pages?.length < 2) {
      addAllPages("export");
    } else {
      dispatch(setDesignStore(JSON.stringify(store.toJSON())))
      navigate("/export", {
        state: {
          // storeVal: storeJson,
          storeVal: JSON.stringify(store.toJSON()),
          isChanged: isChanged,
        },
      });
    }
  };
  const navigateVariationPage = () => {
    dispatch(setDesignStore(JSON.stringify(store.toJSON())))
    navigate("/variation", {
      state: {
        // storeVal: storeJson,
        storeVal: JSON.stringify(store.toJSON()),
        isChanged: isChanged,
      },
    });
  };

  const sizeChangeHandler = (e) => {
    const val = e.target.value;
    setSizeFormat(val);
    store.setUnit({
      unit: val === "inch" ? "in" : "px",
      dpi: 72,
    });
  };

  const customFontFamily = () => {
    return (
      <>
        <FontComponant store={store} />
      </>
    );
  };

  console.log("location ischanged in polot", isChanged);
  return (
    <>
      {/* <button onClick={navigateHomePage}>Go to Home page</button>
      <button onClick={navigateVariationPage}>Go to variation page</button>
      <button onClick={navigateExportPage}>Go to export page</button> */}
      {/* <button onClick={handleAddName}>Add Player Name</button>
      <button onClick={navigateVariationPage}>Go to variation page</button>
      <select value={sizeFormat} onChange={sizeChangeHandler}>
        <option value={"pixels"}>Pixels</option>
        <option value={"inch"}>Inch</option>
      </select> */}

      <PolotnoContainer
        style={{ width: "100vw", height: "100vh" }}
        className="polotno-container"
      >
        <SidePanelWrap className="polotno-sidebar">
          <Link to="/" className="sidebar-logo" onClick={(e) => {
            e.preventDefault(); 
            window.location.href = "/";
          }}>
            <img src={"/assets/images/teedex-logo.png"} alt="Varient logo" className="sidebar-logo-main" />
            <img src={"/assets/images/teedex-logo-hover.png"} alt="Varient logo" className="sidebar-logo-hover" />
          </Link>
          <Sidebar store={store} />
        </SidePanelWrap>
        <WorkspaceWrap className="polotno-workspace">
          <div className="artboard--main__header--center" style={{paddingLeft: ".781vw"}}>
            <div className="artboard--main__tabs">
              <button
                className="artboard--main__tabs--nav__item active"
                onClick={navigateHomePage}
              >
                Design
              </button>
              <button
                className="artboard--main__tabs--nav__item"
                onClick={navigateVariationPage}
              >
                Variation
              </button>
              <button
                className="artboard--main__tabs--nav__item"
                onClick={navigateExportPage}
              >
                Export
              </button>
            </div>
          </div>
          <div className="artboard--main__header--right variation-button">
            <a onClick={navigateVariationPage}>
              <img
                src={"/assets/images/list_white-icn.svg"}
                alt="Variation Icon"
              />
              Add Variation
            </a>
          </div>
          <Toolbar
            store={store}
            components={{ TextFontFamily: customFontFamily, TextAiWrite }}
          />
          <Workspace
          renderOnlyActivePage={renderOnlyActivePage}
            store={store}
            components={{
              PageControls: ({ store, page, xPadding, yPadding }) => {
                const hasManyPages = store.pages.length > 1;
                const index = store.pages.indexOf(page);
                return (
                  <div className="artboard-page-controls">
                    <div
                      style={{
                        position: "absolute",
                        top: yPadding - 20 + "px",
                        left: xPadding + "px",
                      }}
                      className="artboard-page"
                    >
                      <EditableText
                        disabled
                        className="artboard-page-name"
                        value={
                          page.id?.split("_").join(" ")?.toUpperCase() ||
                          "Untitled page"
                        }
                        onChange={(val) => {
                          page.set({
                            custom: {
                              ...page.custom,
                              name: val,
                            },
                          });
                        }}
                      />
                      <EditableText
                        className="artboard-page-size"
                        disabled
                        value={page.custom[sizeFormat]}
                        onChange={(val) => {
                          page.set({
                            custom: {
                              ...page.custom,
                              name: val,
                            },
                          });
                        }}
                      />
                    </div>
                    <div
                      style={{
                        position: "absolute",
                        top: yPadding - 30 + "px",
                        right: xPadding + "px",
                      }}
                      className="artboard-sizes"
                    >
                      <select value={sizeFormat} onChange={sizeChangeHandler}>
                        <option value={"pixels"}>Pixels</option>
                        <option value={"inch"}>Inch</option>
                      </select>
                    </div>
                    <div
                      style={{
                        position: "absolute",
                        top: yPadding - 40 + "px",
                        right: xPadding + "px",
                      }}
                    ></div>
                  </div>
                );
              },
              TextAiWrite,
              Tooltip: showTooltip ? Tooltip : null,
            }}
          />
          {/* <ZoomButtons store={store} /> */}
          {/* <div style={{ display: "flex" }}>
            <button onClick={timelineHandler}>
              {showTimeline ? "Hide All Pages" : "Show All Pages"}
            </button>
            <button onClick={refreshHandler}>Refresh canvas</button>
          </div> */}
          {/* <div className="pages-controller">
            <div className="pages-controller-block">
              <div className="pages-controller-buttons">
                <button onClick={timelineHandler}>
                  {showTimeline ? "Hide All Pages" : "Show All Pages"}
                </button>
                <button onClick={refreshHandler}>Refresh canvas</button>
                <button onClick={handleUnlockClick}>Release Image</button>
              </div>
              <ZoomButtons store={store} />
            </div>
          </div> */}
          {smThumbs && (
            <div className="all-sm-pages-list">
              <div className="all-sm-pages-items">
                {/* Master Page */}

                {/* Dynamic Page Items */}
                {thumbnails.map(({ id, image, isActive, label }, index) => (
                <div key={index} className={`sm-page-item ${id === "master" ? "active" : isActive ? "active" : ""}`}
                >
                <span>{label}</span>
                <img src={image} alt={`Thumbnail ${index}`} loading="lazy" className="page-img" />
              </div>
                ))}
              </div>
            </div>
          )}
          {
            !showTimeline ? (
              <div className="pages-controller-items">
                <div className="pages-controller-item">
                  <div className="pages-controller-buttons">
                    <span onClick={smTimeLineHandler}>
                      {smThumbs ? (
                        <img
                          src={"/assets/images/hide-pages-icn.svg"}
                          alt="Show Layers"
                        />
                        ) : (
                          <img
                          src={"/assets/images/show-pages-icn.svg"}
                          alt="Show Layers"
                        />
                        )
                      }
                      
                    </span>
                    <span onClick={smTimeLineHandler} className={smThumbs ? "selected" : ''}>
                      <img
                        src={"/assets/images/list-pages-icn.svg"}
                        alt="List Pages"
                      />
                    </span>
                    <span onClick={timelineHandler} className={showTimeline ? "selected" : ''}>
                      <img
                        src={"/assets/images/all-pages-icn.svg"}
                        alt="All Pages"
                      />
                    </span>
                    <button onClick={refreshHandler}>
                      <img
                        src={"/assets/images/refresh_page_icn.svg"}
                        alt="Refresh Icon"
                      />
                      Refresh canvas
                    </button>
                  </div>

                  <div className="artboard--main--actions--zoom">
                    <img
                      src={"/assets/images/zoom_in-icn.svg"}
                      alt="Zoom"
                    />
                    Zoom
                    <div className="range-block">
                        <input type="range" min="0" max="10" step="1" value="3" />
                        <div className="dropdown-list">
                            <span>12%</span>
                            <ul>
                                <li className="selected">12%</li>
                                <li>14%</li>
                                <li>16%</li>
                                <li>18%</li>
                                <li>20%</li>
                            </ul>
                        </div>
                    </div>
                  </div>

                  <div className="artboard-open-full">
                    <img
                      src={"/assets/images/open_in_full_icn.svg"}
                      alt="Show Layers"
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div className="lgTimeLine-controller-buttons">
                <span onClick={smTimeLineHandler} className={smThumbs ? "selected" : ''}>
                  <img
                    src={"/assets/images/list-pages-icn.svg"}
                    alt="List Pages"
                  />
                </span>
                <span onClick={timelineHandler} className={showTimeline ? "selected" : ''}>
                  <img
                    src={"/assets/images/all-pages-icn.svg"}
                    alt="All Pages"
                  />
                </span>
              </div>
            )
          }
          
          {/* {showTimeline && <PagesTimeline store={store} />} */}
          {/* {showTimeline && <CustomPageTimeline store={store} allThumbs={allThumbs} />} */}
          {/* {showTimeline && <PagesTimeline store={store} />} */}
          {showTimeline && <CustomPageTimeline store={store} allThumbs={allThumbs} handlePageClick={handlePageClick} />}
          {/* </div> */}
        </WorkspaceWrap>
      </PolotnoContainer>
    </>
  );
}